export default __webpack_public_path__ + "static/media/ct5.2.a50dfa9f.png";